import { PF } from '@app/components/RecordModal/data/constants';

import type { FC } from 'react';

interface ClientMenuLabelProps {
  name?: string | null;
}

export const ClientMenuLabel: FC<ClientMenuLabelProps> = ({ name = null }) => (
  <div className={`${PF}__sidebar-client-label`}>
    <div className={`${PF}__sidebar-client-label-title`}>Клиент</div>
    {name !== null && (
      <div className={`${PF}__sidebar-client-label-name no-wrap-text`}>
        {name}
      </div>
    )}
  </div>
);
